import Navbar from "@/components/Common/Navbar";
import AdminBreadcrumb from "@/features/admin/components/AdminBreadcrumb";

import TokenForm from "../components/AddNewToken/TokenForm";

export default function AddNewTokenContainer() {
  return (
    <main className="scrollbar-thin flex h-screen min-h-0 flex-1 flex-col gap-7 overflow-y-auto p-3 px-4 pr-0 pl-6 transition-all duration-300">
      <div className="mb-5 flex-shrink-0">
        <Navbar subtitle="manager" />
      </div>

      <div className="flex-shrink-0 px-4 transition-all duration-300 md:px-16 lg:px-[120px]">
        <AdminBreadcrumb title={`Create new token`} />
      </div>

      <div className="min-h-0 flex-1 transition-all duration-300">
        <div className="mx-auto flex max-h-[88px] w-full max-w-[967px] flex-row items-center justify-center">
          <TokenForm />
        </div>
      </div>
    </main>
  );
}
